module.exports = __webpack_public_path__ + "static/popup-ssg-0e22fe6a3d13634d15a8d06583b015ff.png";